export default "__VITE_ASSET__CZ_5Ah14__"